'use client'

import { useEffect } from 'react'

export function DisableRightClick() {
    useEffect(() => {
        const isProduction = process.env.NODE_ENV === 'production'

        if (!isProduction) return

        const handleContextMenu = (e: MouseEvent) => {
            e.preventDefault()
        }

        document.addEventListener('contextmenu', handleContextMenu)

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu)
        }
    }, [])

    return null
}
